(function() {
	'use strict';
	angular.module('quantixApp').controller('CustomTeamDownloadsFilterController',
    CustomTeamDownloadsFilterController);
    CustomTeamDownloadsFilterController.$inject = [ '$scope','$sessionStorage','$uibModalInstance', 'CompanyReportService'];
	function CustomTeamDownloadsFilterController($scope,$sessionStorage,$uibModalInstance, CompanyReportService) {
        
		
        $scope.clear = function() {
			$uibModalInstance.dismiss('cancel');
        }

		$scope.applyTeamDownloadFilters = function() {
            // var filter = {
            //     selectedCompanies: $scope.selectedCompanies,
            //     users: $scope.selectedUsers,
            //     fromDate: $scope.fromDate,
            //     toDate: $scope.toDate
            // };
            CompanyReportService.applyTeamDownloadFilters($scope.filter).then(function(response) {
                $scope.setData(response);
			}, function(error) {});
        }

		$scope.applyTeamDownloadFiltersExt = function() {
			$scope.filter.clientId = $sessionStorage.clientModel;
            // var filter = {
            //     selectedCompanies: $scope.selectedCompanies,
            //     users: $scope.selectedUsers,
            //     fromDate: $scope.fromDate,
            //     toDate: $scope.toDate
            // };
            CompanyReportService.applyTeamDownloadFiltersExt($scope.filter).then(function(response) {
                $scope.setData(response);
			}, function(error) {});
        }

        // $scope.fromDate = new Date();
		// $scope.toDate = new Date();
		// $scope.usageTrackerGrid = '';
		// $scope.formats = [ 'dd-MMMM-yyyy', 'yyyy/MM/dd', 'dd.MM.yyyy',
		// 		'shortDate', 'dd-MMM-yyyy' ];

		// $scope.format = $scope.formats[0];
        // $scope.requiredFormat = $scope.formats[4];
        // // $scope.selectedUsers = []; 
        // // $scope.selectedCompanies = []; 

        // $scope.clear = function() {
		// 	$uibModalInstance.dismiss('cancel');
        // }
		
		// $scope.applyTeamDownloadFilters = function() {
        //     var filter = {
        //         selectedCompanies: $scope.selectedCompanies,
        //         users: $scope.selectedUsers,
        //         fromDate: $scope.fromDate,
        //         toDate: $scope.toDate
        //     };
        //     CompanyReportService.applyTeamDownloadFilters(filter).then(function(response) {
        //         $scope.teamDownloadModel = {
		// 			dataProvider : response,
		// 			delegate : $scope
		// 		};
		// 	}, function(error) {});
        // }
       
       	// $scope.restFilter = function() {
		// 	var d = new Date(); 
		// 	d.setMonth(d.getMonth() - 6);
		// 	$scope.fromDate = d;
		// 	$scope.toDate = new Date();
		// }
		// $scope.restFilter();

		// $scope.popup3 = {
		// 	opened : false
		// };
		// $scope.popup4 = {
		// 	opened : false
		// };
		// $scope.open3 = function($event) {
		// 	$scope.popup3.opened = true;
		// };
		// $scope.open4 = function($event) {
		// 	$scope.popup4.opened = true;
		// };

        
	}

})();